﻿
(function () {


    window.dataLayer = window.dataLayer || [];
    window.googlefc = window.googlefc || {};

    var gtag = gtag||function(){dataLayer.push(arguments);}

    function render() {
        function c(name) {
            this.node = document.createElement(name);
            return this;
        }

        c.prototype.a = function (name, value) {
            this.node.setAttribute(name, value)
            return this;
        }

        c.prototype.n = function (name) {
            var item = new c(name);
            this.node.appendChild(item.node);
            return item;
        }

        c.prototype.h = function (text) {
            this.node.innerHTML = text;
            return this;
        }

        c.prototype.cl = function (action) {
            this.node.addEventListener('click', action);
            return this;
        }

        var style = `.data-consent-management{display:block;width: 100%;background:var(--secondary-color-500);max-height:0;transition: 0.8s cubic-bezier(0.4, 0.0, 0.2, 1) all;}
        .data-consent-management.active{max-height:16vh;z-index: 9;pointer-events: all;}
        .data-consent-management .content{display:-webkit-flex;display:flex;width:100%;margin:0 auto;max-width:1440px;padding:6px;box-sizing:border-box;align-items: center;justify-content: center;flex-flow: row wrap;}
        .data-consent-management .content h2{width:100%;color:var(--primary-color-500);font-size:16px;margin:0 0 6px 0;}
        .data-consent-management .content p{color:rgba(255,255,255,0.96);margin:0;font-size:12px;text-align: justify;line-height: 1.4;width: auto;padding: 8px 0 4px 0;}
        .data-consent-management .content p a{color:rgba(255,255,255,0.96);text-decoration: underline;}
        .data-consent-management .content .action{display:flex;display:-webkit-flex;align-items: center;}
        .data-consent-management.active .content p+div{justify-content: space-between;display:flex;flex-flow: row wrap;}
        .data-consent-management .content .action a+a{margin-left:16px;background-color: var(--secondary-color-400);}
        .data-consent-management .content .action a{color: rgb(255,255,255);background-color: var(--primary-color-500);border: none;border-radius: 2px;position: relative;height: 36px;margin: 0;min-width: 64px;padding: 0 16px;display: inline-block;font-family: ""Roboto"", ""Helvetica"", ""Arial"", sans-serif;font-size: 14px;font-weight: 400;text-transform: capitalize;line-height: 1;letter-spacing: 0;overflow: hidden;will-change: box-shadow;-webkit-transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1);transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1);-o-transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1);transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1);transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1);outline: none;cursor: pointer;text-decoration: none;text-align: center;line-height: 36px;vertical-align: middle;}                                
        .data-consent-management .content .action label{background-color:rgba(0,0,0,0);border:1px solid var(--primary-color-500);box-sizing:border-box;border-radius: 2px;position: relative;height: 36px;margin: 0;min-width: 64px;padding: 0 16px;display: inline-block;font-family: ""Roboto"", ""Helvetica"", ""Arial"", sans-serif;font-size: 14px;font-weight: 400;text-transform: capitalize;line-height: 1;letter-spacing: 0;overflow: hidden;will-change: box-shadow;-webkit-transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1);transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1);-o-transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1);transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1);transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1);outline: none;cursor: pointer;text-decoration: none;text-align: center;line-height: 36px;vertical-align: middle;color: rgba(255,255,255,0.96);}
        .data-consent-management .content .action label+label{background-color: var(--primary-color-500);border: none;margin:0 0 0 8px;}
        .data-consent-management .consent-types label:before {background: var(--primary-color-500);}
        .data-consent-management .consent-types label:after {content:attr(text);}
        .data-consent-management .consent-types label{color: rgba(255, 255, 255, 0.96);position:relative;display: inline-block;margin: 8px 8px 8px 0px;cursor: pointer;border: 1px solid var(--primary-color-500);border-radius: 96px;padding: 8px 80px 8px 16px;}
        .data-consent-management .consent-types label input{display:none;}
        .data-consent-management .consent-types label span{width: 56px;height: 24px;background: rgba(255, 255, 255, 0.96);display: block;position: absolute;right: 6px;color: var(--primary-color-50);border-radius: 16px;font-weight:500;transform: translateY(-2px);}
        .data-consent-management .consent-types label span:before{content: "";width: 22px;height: 22px;display: inline-block;background: var(--primary-color-400);border-radius: 50%;transform: translate(1px, 1px);}
        .data-consent-management .consent-types label span:after{content: "OFF";color: var(--primary-color-400);display: inline-block;line-height: 0;transform: translate(5px, -5px);}
        .data-consent-management .consent-types label span:has(>input:checked):after{content:"ON";color: rgba(255, 255, 255, 0.96);transform: translate(-12px, -5px);}
        .data-consent-management .consent-types label span:has(>input:checked):before{background: rgba(255, 255, 255, 0.96);transform: translate(33px, 1px);}
        .data-consent-management .consent-types label span:has(>input:checked){background: var(--primary-color-500);}
        .data-consent-management.active .content p,.data-consent-management.active .content p+div{width: calc(100% - 125px) !important;}
        @media only screen and (max-width:1024px){.data-consent-management .content p,.data-consent-management.active .content p+div{width:100%;text-align: center;}.data-consent-management .content .action{width: 100%;padding-top:8px;padding-left:0;justify-content: center;}}
        @media only screen and (max-width:640px){.data-consent-management .content .action{width: 100%;justify-content: space-between;}}`;        
        var cmp = new c('div').a('class', 'data-consent-management active');
        cmp.n('style').h(style);
        var content = cmp.n('div').a('class', 'content');
        var consentContent = content;// content.n('div').a('class', 'consent-info');
        consentContent.n('p').a('ag-l-k', 'FORM_CONSENT').h('We use cookies and similar technologies to make our site work, improve performance, and show relevant content. You can accept all cookies, reject non‑essential ones, or manage your choices. For more details, see our <a title="Our Privacy Policy" href="/privacy-policy">Privacy Policy</a>.');
        var consentActionWrapper = consentContent.n('div')
        var consentTypes = consentActionWrapper.n('div').a('class', 'consent-types');
        consentTypes.n('label').a('for', 'consent_t1').a("text", "Personalization").n('span').n('input').a('id', 'consent_t1').a("type", "checkbox").a('checked', 'true').a('value', 'personalization');
        consentTypes.n('label').a('for', 'consent_t2').a("text", "Analytics").n('span').n('input').a('id', 'consent_t2').a("type", "checkbox").a('checked', 'true').a('value', 'analytics');
        var actionWrapper = consentActionWrapper.n('div');
        actionWrapper.a('class', 'action').n('label').cl(function () { window.localStorage.setItem('CMP', '0'); setConsentsMarkedToStore(cmp.node); cmp.node.remove(); }).a('class', 's-c-p s-bi-lg').a('aria-label', 'Decline').a('data-cmp', '0').a('ag-l-k', 'BUTTON_DECLINE').h('Decline');
        actionWrapper.a('class', 'action').n('label').cl(function () { window.localStorage.setItem('CMP', '1'); setConsentsMarkedToStore(cmp.node); cmp.node.remove(); }).a('class', 's-c-p s-bi-lg').a('aria-label', 'Accept').a('data-cmp', '1').a('ag-l-k', 'BUTTON_ACCEPT').h('Accept');

        if (document.querySelector('.agora-layout-header') != null) {
            document.querySelector('.agora-layout-header').insertBefore(cmp.node, document.querySelector('.agora-layout-header').firstChild);
        } else {
            document.body.appendChild(cmp.node);
        }
        if (window.agLanguage)
            window.agLanguage.refreshLocale();
    }

    function getConsentsMarked(node) {
        var result = [];
        var consents = node.querySelectorAll('input[type="checkbox"]');
        consents.forEach(function (item) {
            if (item.checked) result.push(item.value);
        });
        return result;

    }

    function setConsentsMarkedToStore(node) {
        setConsentsToStore(getConsentsMarked(node));
    }

    function setConsentsToStore(consents){ 
        window.localStorage.setItem('CMPALLOW', JSON.stringify(consents));
    }

    function getConsentsMarkedFromStore() {
        var result = window.localStorage.getItem('CMPALLOW');
        if (result)
            return JSON.parse(result);
        else
            return null;
    }

    function getConsentMappings(){
        return{
            'personalization': ['ad_storage','ad_user_data', 'ad_personalization'],
            'analytics': ['analytics_storage']
        };
    }

    function upadateConsentsToVendor(init){
        var consentMappings = getConsentMappings();
        var consents = getConsentsMarkedFromStore();   
        var gtagConsents = {};
        if(init && consents == null){
            consentMappings.forEach(function(consent) {
                if (consentMappings[consent]) {
                    consentMappings[consent].forEach(function(gtagConsent) {
                        gtagConsents[gtagConsent] = 'denied';
                    });
                }
            });
            gtag('consent', 'default', gtagConsents);
        }else{          
            consents.forEach(function(consent) {
                if (consentMappings[consent]) {
                    consentMappings[consent].forEach(function(gtagConsent) {
                        gtagConsents[gtagConsent] = 'granted';
                    });
                }
            });
            gtag('consent', 'update', gtagConsents);
        }
    }

    if (window.localStorage.getItem('CMP') == null)
    {
        render();        
    }
    
    upadateConsentsToVendor(true);

    googlefc.controlledMessagingFunction = async (message) => {
        const shouldDisplayOfferwall = await determineIfUserIsSubscriber();
        const applicableMessageTypes = [];

        if (!shouldDisplayOfferwall) {
            applicableMessageTypes.push(window.googlefc.MessageTypeEnum.OFFERWALL);
            message.proceed(false, applicableMessageTypes);
        } else {        
            message.proceed(true);
        }
    };

    async function determineIfUserIsSubscriber() {        
        return window.localStorage.getItem('CMP') != null;
    }

})();


